import { Injectable } from '@angular/core'
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http'
import { catchError, finalize, Observable, of, throwError } from 'rxjs'
import { LoadingService } from '../common/loading.service'
import { AuthService } from '../auth/auth.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private loadingService: LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loadingService.show()
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.hide()
      }),
      catchError(error => {
        if (error.error?.message == 'Token may have expired. Please renew your session.' && error.status == 401) {
          return this.handleTokenRefresh(request, next)
        } else {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            // Token is already invalid, so the logout API call would fail too: just clear it locally
            this.authService.clearLocalStorageAndRedirectToLogin()
          }
          return throwError(() => JSON.stringify(error))
        }
      })
    )
  }

  private handleTokenRefresh(request: HttpRequest<any>, next: HttpHandler) {
    return this.authService.refreshToken(request, next)
  }
}
